var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTestCaseHover({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 21,
    viewBox: "0 0 17 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.327 4.40606C7.64933 3.55044 9.35067 3.55044 10.673 4.40606L14.405 6.82086C15.623 7.60898 15.623 9.39102 14.405 10.1791L10.673 12.5939C9.35067 13.4496 7.64932 13.4496 6.32699 12.5939L2.59503 10.1791C1.37704 9.39102 1.37704 7.60898 2.59503 6.82086L6.327 4.40606Z",
    stroke: "#1847CA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.327 8.40606C7.64933 7.55044 9.35067 7.55044 10.673 8.40606L14.405 10.8209C15.623 11.609 15.623 13.391 14.405 14.1791L10.673 16.5939C9.35067 17.4496 7.64932 17.4496 6.32699 16.5939L2.59503 14.1791C1.37704 13.391 1.37704 11.609 2.59503 10.8209L6.327 8.40606Z",
    stroke: "#1847CA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestCaseHover);
export default __webpack_public_path__ + "static/media/test-case-hover.01fb5d94d75d2af3cb01fa1c4c211083.svg";
export { ForwardRef as ReactComponent };